module.exports = __webpack_public_path__ + "static/img/banber (4).6ea929e7.png";